import moment from 'moment';

import { GameData, TeamData } from 'types';
import { classes, parseClock, parsePeriod } from 'utils';
import { VS } from 'assets/vector';

import bg from 'assets/images/scoreboard_bg.png';
import styles from './ScoreBoard.module.scss';

type Props = { data: GameData };

const ScoreBoard = ({ data }: Props) => {
  const { homePosition, home, away, clock, status, scheduled, period } = data;

  let rightTeam = home;
  let leftTeam = away;
  let s1, s2;
  let isLive = false;

  switch (status) {
    case 'scheduled':
      s1 = moment(scheduled).format('MMM DD');
      s2 = moment(scheduled).format('LT');
      break;

    case 'inprogress':
    case 'live':
      isLive = true;
      s1 = parseClock(clock);
      s2 = parsePeriod(period);
      break;

    case 'final':
      s2 = status;
      break;
  }

  if (homePosition === 'left') {
    rightTeam = away;
    leftTeam = home;
  }

  const renderTeam = ({ name, logo, score }: TeamData, reverse?: boolean) => (
    <div className={classes(styles.team, reverse ? styles.reverse : '')}>
      <div className={styles.wrapper}>
        <div
          className={styles.logo}
          style={logo ? { backgroundImage: `url(${logo})` } : undefined}
        />

        <div className={styles.name}>{name}</div>
      </div>

      <div className={styles.score}>
        <span>{typeof score === 'number' ? score : '-'}</span>
      </div>
    </div>
  );

  return (
    <div
      className={classes(styles.scoreboard, isLive ? styles.live : '')}
      style={{ backgroundImage: `url(${bg})` }}
    >
      {renderTeam(leftTeam)}

      <div className={styles.info}>
        <div
          className={styles.s1}
          style={s1 ? undefined : { backgroundColor: 'transparent' }}
        >
          {s1}
        </div>

        <div className={styles.vs}>
          <VS />
        </div>

        <div
          className={styles.s2}
          style={s2 ? undefined : { backgroundColor: 'transparent' }}
        >
          {s2}
        </div>
      </div>

      {renderTeam(rightTeam, true)}
    </div>
  );
};

export default ScoreBoard;
